import React, {Component} from 'react';
import {withRouter} from 'react-router-dom'
import objeler, {applyAccountContext} from '../components/objeler'
import axiosInstance from '../components/token/axiosInstance'
class Direct extends Component<props> {
    constructor(props) {
        super(props);
        this.state = {
            email: "",
            password: "",
            validated: false,
            error: false,
            errorText: '',
            wrongUser: false,
            wrongPassword: false
        };
    }

    componentWillUnmount() {
        this.setState = (state, callback) => {
            return;
        };
    }

    componentDidMount() {
        let search = window.location.search;
        let params = new URLSearchParams(search);

        let tok = params.entries().next().value;
        let token = ""
        if (tok !== undefined && tok !== null && tok.length !== 0) {
            token = tok[0]
        }

        // M3.5/H3 — strip the token from the URL bar IMMEDIATELY, before
        // any await. If we wait for the API response first, an attacker
        // who can read the address bar (screen recording, screenshot,
        // shoulder-surfing) gets a multi-second window. replaceState also
        // means the browser's session/back-forward history won't retain
        // the token-bearing URL — refresh / back button won't replay it.
        // The replay cache on the server is the second layer; this just
        // shrinks the exposure surface.
        if (token) {
            try {
                window.history.replaceState({}, document.title, '/direct');
            } catch (e) {
                // Old browsers without History API fall through. Server
                // replay cache still protects against URL reuse.
            }
        }

        axiosInstance.get(window.GET_API_URL(process.env.REACT_APP_SERVICE) + '/api/login/gettokenex2?' + token
            , {
                responseType: 'text'
            }
        ).then((response) => {
            let token = response.data
            if (token.status) {
                var usr = {
                    Email: token.email,
                    Origin: "Direct",
                    From: "Direct",
                    SessionId: null,
                    Token: {
                        AccessToken: token.accesstoken,
                        RefreshToken: token.refreshtoken
                    }

                }
                let filename = token.filename;
                objeler["User"] = usr

                // ─── M3.5/H2 — extract M2 multi-tenant claims from JWT ───
                // The backend's gettokenex2 endpoint issues a fresh access
                // token with accountId / role / accountName claims (M2).
                // Login.js already applies these via applyAccountContext;
                // direct-link entry was missing the call, so 3rd-party
                // launches landed in /frame without an account context
                // and Editor / FileExplorer fell back to legacy single-
                // user mode. Same pattern as Login.js — keep them in sync.
                const hasContext = applyAccountContext(token.accesstoken);
                // M3.5/H4 — removed: console.log('Direct: M2 account context applied:', ...)
                // Logged accountId/accountName/role on every direct-link landing.
                void hasContext;

                this.props.history.push({
                    pathname: '/frame',
                    state: {fromUrl: 'Login', filename: filename}
                })
            }
        })

    }

    async handleSubmit(e) {
        var isError = false;
        var errText = '';
        this.setState({wrongUser: false});
        this.setState({wrongPassword: false});
        const form = e.currentTarget;
        e.preventDefault();
        if (form.checkValidity() === false) {
            e.stopPropagation();
        } else {
            var token = '';
            const data = new FormData();
            data.append('Email', this.state.email);
            data.append('Password', this.state.password);
            await axiosInstance.post(window.GET_API_URL(process.env.REACT_APP_SERVICE) + '/api/login/login', data
            ).then((response) => {
                if (response.data.status >= 100) {
                    e.stopPropagation();
                    if (response.data.status == 100) {
                        this.setState({wrongUser: true, errorText: 'Hatalı Kullanıcı'});
                        this.setState({wrongPassword: false});
                        return;
                    }
                    if (response.data.status == 101) {
                        this.setState({wrongUser: false, errorText: ''});
                        this.setState({wrongPassword: true});
                        return;
                    }
                    // M3.5/H1 — account temporarily locked due to brute-force protection
                    if (response.data.status == 102) {
                        const sec = response.data.retryAfterSeconds || 0;
                        const min = Math.ceil(sec / 60);
                        this.setState({
                            wrongUser: true,
                            errorText: `Hesabınız geçici olarak kilitlendi. ${min} dakika sonra deneyin.`
                        });
                        this.setState({wrongPassword: false});
                        return;
                    }
                }
                objeler.User = response.data;
                token = response.data.token;
                objeler['token'] = token;

                // M3.5/H2 — extract M2 multi-tenant claims from JWT
                // (parity with Login.js handleSubmit)
                const accessToken = response.data?.Token?.AccessToken
                                 || response.data?.token?.accessToken
                                 || response.data?.AccessToken;
                applyAccountContext(accessToken);

                this.props.history.push({
                    pathname: '/frame',
                    state: {fromUrl: 'Login'}
                })
            }).catch((error) => {
                isError = true;
                this.setState({wrongUser: true, errorText: 'Network error'});
            });
        }
        this.setState({validated: true});
    }

    render() {
        return (
            <div>
            </div>
        );
    }
}

export default withRouter(Direct);